import React from "react";
import { Space, Tag, Tooltip, Typography } from "antd";
import { ExportOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { TreeNode } from "../../../services/content-tree/content-tree.types";
import { STATUS_TAG, TYPE_ABBR, findHighlightRange, getEditPath } from "./utils";

const { Text } = Typography;

interface NodeTitleProps {
  node: TreeNode;
  searchTerm: string;
}

// Renders a single Tree node's label: type tag, id + title (with the search
// term highlighted when it matches), status tag, contextual meta, and an
// "Editar" link when the node type has a standalone edit page.
const NodeTitle: React.FC<NodeTitleProps> = ({ node, searchTerm }) => {
  const editPath = getEditPath(node);
  const highlight = findHighlightRange(node.title, searchTerm);

  const titleContent = highlight ? (
    <>
      {node.title.slice(0, highlight[0])}
      <mark>{node.title.slice(highlight[0], highlight[1])}</mark>
      {node.title.slice(highlight[1])}
    </>
  ) : (
    node.title
  );

  const statusTag =
    node.status !== "active" ? (
      <Tag color={STATUS_TAG[node.status].color}>
        {STATUS_TAG[node.status].label}
      </Tag>
    ) : null;

  return (
    <Space size={4} wrap onClick={(e) => e.stopPropagation()}>
      <Tag>{TYPE_ABBR[node.type] ?? node.type.toUpperCase()}</Tag>
      <Text>
        #{node.id} {titleContent}
      </Text>
      {statusTag &&
        (node.status_detail ? (
          <Tooltip title={node.status_detail}>{statusTag}</Tooltip>
        ) : (
          statusTag
        ))}
      {node.type === "course" && node.meta?.week && (
        <Tag color="default">Semana {node.meta.week}</Tag>
      )}
      {node.type === "activity" && node.meta?.activity_type && (
        <Text type="secondary" style={{ fontSize: 12 }}>
          {node.meta.activity_type}
        </Text>
      )}
      {editPath && (
        <Space size={2}>
          <Link to={editPath}>Editar</Link>
          <a href={editPath} target="_blank" rel="noreferrer" title="Abrir en pestaña nueva">
            <ExportOutlined />
          </a>
        </Space>
      )}
    </Space>
  );
};

export default NodeTitle;
